import React, { FC, ReactNode } from 'react'
import { Wrapper, Title, Text } from './styled'

interface ComponentProps {
	title: string
	children: ReactNode
	className?: string
	titleStyle?: string
	textStyle?: string
	text?: string
}

export const AdvantagesTabsElement: FC<ComponentProps> = ({
	title,
	children,
	className,
	titleStyle = '',
	textStyle = '',
	text = '',
}) => (
	<Wrapper className={className}>
		{children}
		<Title titleStyle={titleStyle}>{title}</Title>
		{text && <Text textStyle={textStyle}>{text}</Text>}
	</Wrapper>
)
